"use strict";

var markers = {};

var scaleFactor = 0.5;
var spriteWidth = 412;
var spriteHeight = 226;

var normalOffset = 0;
var activeOffset = 150;

var offsets = {
  'teacoffee-shops': 0,
  'places-to-drink': 54,
  'places-to-eat': 108,
  'things-to-do': 162,
  'for-kids': 216,
  'shops-and-delis': 270
};

for (var key in offsets) {
  var offset = offsets[key];
  markers[key] = {};
  markers[key].normal = new google.maps.MarkerImage(
    ofs.static("images/maps/markers.png"),
    new google.maps.Size(54 * scaleFactor, 74 * scaleFactor),  // desired size
    new google.maps.Point(offset * scaleFactor, normalOffset * scaleFactor), // offset within the scaled sprite
    null,
    new google.maps.Size(spriteWidth * scaleFactor, spriteHeight * scaleFactor) // scaled size of the entire sprite
  );

  markers[key].active = new google.maps.MarkerImage(
    ofs.static("images/maps/markers.png"),
    new google.maps.Size(54 * scaleFactor, 74 * scaleFactor),  // desired size
    new google.maps.Point(offset * scaleFactor, activeOffset * scaleFactor), // offset within the scaled sprite
    null,
    new google.maps.Size(spriteWidth * scaleFactor, spriteHeight * scaleFactor) // scaled size of the entire sprite
  );
}

markers.home = new google.maps.MarkerImage(
  ofs.static("images/maps/markers.png"),
  new google.maps.Size(52 * scaleFactor, 74 * scaleFactor),  // desired size
  new google.maps.Point(360 * scaleFactor, 0 * scaleFactor), // offset within the scaled sprite
  null,
  new google.maps.Size(spriteWidth * scaleFactor, spriteHeight * scaleFactor) // scaled size of the entire sprite
);

markers.shadow = new google.maps.MarkerImage(
  ofs.static("images/maps/markers.png"),
  new google.maps.Size(50 * scaleFactor, 20 * scaleFactor),  // desired size
  new google.maps.Point(361 * scaleFactor, 80 * scaleFactor), // offset within the scaled sprite
  new google.maps.Point(25 * scaleFactor, 10 * scaleFactor),
  new google.maps.Size(spriteWidth * scaleFactor, spriteHeight * scaleFactor) // scaled size of the entire sprite
);

export default markers;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/google/maps/markers.js
 **/